// Italian Bio/Eco Partners Data

export interface Partner {
  id: number
  name: string
  website: string
  logo: string
  categories: string[]
  description: string
  productsDescription: string
  locations?: number
  activeRewards?: number
  totalRedemptions?: number
  conversionRate?: number
  joinedDate: string
}

export const partners: Partner[] = [
  {
    id: 1,
    name: 'La Saponaria',
    website: 'https://www.lasaponaria.it',
    logo: 'https://blog.lasaponaria.it/hubfs/LaSaponaria-5.jpg',
    categories: ['Cosmetici Bio', 'Materie Prime', 'Plastic Free'],
    description:
      'Cosmetici naturali e biologici certificati, prodotti con ingredienti di alta qualità e packaging sostenibile.',
    productsDescription: 'cosmetici bio, materie prime, plastic free',
    locations: 20,
    activeRewards: 12,
    totalRedemptions: 3420,
    conversionRate: 18.5,
    joinedDate: '2024-01-15',
  },
  {
    id: 2,
    name: 'NaturaSì',
    website: 'https://www.naturasi.it',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/Naturas%C3%AC_Logo.svg/250px-Naturas%C3%AC_Logo.svg.png',
    categories: ['Supermercato Bio', 'Alimentari', 'Detergenza Eco'],
    description:
      "Catena di supermercati specializzata in prodotti biologici e naturali, con un'ampia selezione di alimenti freschi e confezionati.",
    productsDescription: 'supermercato bio, alimentari, detergenza eco',
    locations: 45,
    activeRewards: 28,
    totalRedemptions: 8750,
    conversionRate: 22.3,
    joinedDate: '2024-02-01',
  },
  {
    id: 4,
    name: 'Biosapori',
    website: 'https://www.biosapori.com',
    logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThSa_iTnoCIROu27zvH2FkOYz61uIPKSRfxQ&s',
    categories: ['Supermercato Bio', 'Alimentari', 'Casa e Persona'],
    description:
      "Supermercato biologico con prodotti per l'alimentazione, la casa e la cura della persona.",
    productsDescription: 'supermercato bio, alimentari, casa e persona',
    locations: 12,
    activeRewards: 8,
    totalRedemptions: 2340,
    conversionRate: 15.2,
    joinedDate: '2024-03-10',
  },
  {
    id: 5,
    name: 'Verso Natura Conad',
    website: 'https://www.conad.it/prodotti-e-marchi/verso-natura',
    logo: 'https://chisiamo.conad.it/assets/icons/linee/VersoNatura-newlogo.png?_u=9c6c7ba09b561904e0a577d946b3a392e9659d8b',
    categories: ['Alimentari Bio', 'Vegan', 'Detergenza Eco'],
    description:
      'Linea di prodotti biologici, vegani e sostenibili della catena Conad.',
    productsDescription: 'alimentari bio, vegan, detergenza eco',
    locations: 28,
    activeRewards: 18,
    totalRedemptions: 5230,
    conversionRate: 20.1,
    joinedDate: '2024-02-15',
  },
  {
    id: 6,
    name: 'Lavazza',
    website: 'https://www.lavazza.it',
    logo: 'https://globalcoffee.it/wp-content/uploads/2019/01/lavazza-250x250.png',
    categories: ['Caffè', 'Capsule', 'Filiera Sostenibile'],
    description:
      'Storico marchio italiano di caffè con progetti di filiera sostenibile e certificazioni ambientali.',
    productsDescription: 'caffè, capsule, progetti filiera sostenibile',
    locations: 18,
    activeRewards: 14,
    totalRedemptions: 4120,
    conversionRate: 17.6,
    joinedDate: '2024-01-25',
  },
  {
    id: 7,
    name: 'Coop Italia',
    website: 'https://www.coop.it',
    logo: 'https://static.tecnichenuove.it/freshpointmagazine/2017/09/viviverde_logo.jpg',
    categories: ['GDO Bio', 'Linea ViviVerde', 'Detergenza Eco'],
    description:
      'Grande distribuzione organizzata con linee dedicate al biologico e alla sostenibilità ambientale.',
    productsDescription: 'gdo bio, linea ViviVerde, detergenza eco',
    locations: 52,
    activeRewards: 35,
    totalRedemptions: 11250,
    conversionRate: 24.8,
    joinedDate: '2024-01-10',
  },
  {
    id: 8,
    name: 'Ki Group – Ki Ama Bio',
    website: 'https://www.kigroup.com',
    logo: 'https://www.biobottega.com/media/codazon_cache/brand/1200x/ki-group-s-p-a.png',
    categories: ['Distribuzione Bio', 'Negozi Specializzati', 'Vegan'],
    description:
      'Gruppo specializzato nella distribuzione di prodotti biologici e vegani attraverso negozi dedicati.',
    productsDescription: 'distribuzione bio, negozi specializzati, vegan',
    locations: 15,
    activeRewards: 10,
    totalRedemptions: 2890,
    conversionRate: 16.4,
    joinedDate: '2024-03-01',
  },
  {
    id: 9,
    name: 'Biobottega',
    website: 'https://www.biobottega.it',
    logo: 'https://www.biobottega.com/media/codazon_cache/brand/1200x/Marchio_biobottega_G.jpg',
    categories: ['Supermercato Bio', 'Freschi', 'Cosmesi Naturale'],
    description:
      'Supermercato biologico con focus su prodotti freschi e cosmesi naturale certificata.',
    productsDescription: 'supermercato bio, freschi, cosmesi naturale',
    locations: 9,
    activeRewards: 6,
    totalRedemptions: 1850,
    conversionRate: 14.7,
    joinedDate: '2024-03-20',
  },
  {
    id: 10,
    name: 'Piacere Terra',
    website: 'https://www.piacere-terra.it',
    logo: 'https://larussolillo.it/wp-content/uploads/2018/10/logo-piacere-terra-500x300.png',
    categories: ['Negozio Bio', 'Alimentari', 'Casa e Persona'],
    description:
      'Negozio biologico con prodotti alimentari e per la cura della casa e della persona.',
    productsDescription: 'negozio bio, alimentari, casa e persona',
    locations: 6,
    activeRewards: 5,
    totalRedemptions: 1230,
    conversionRate: 12.8,
    joinedDate: '2024-04-05',
  },
  {
    id: 11,
    name: 'Melaverdebio',
    website: 'https://www.melaverdebio.it',
    logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpQTudBXd7OEtcNervYflk3pHfML0nsT3QhQ&s',
    categories: ['Supermercato Bio', 'Intolleranze', 'Cosmesi Eco-Bio'],
    description:
      'Supermercato biologico specializzato in prodotti per intolleranze alimentari e cosmesi eco-biologica.',
    productsDescription: 'supermercato bio, intolleranze, cosmesi eco-bio',
    locations: 8,
    activeRewards: 7,
    totalRedemptions: 1680,
    conversionRate: 13.5,
    joinedDate: '2024-03-15',
  },
  {
    id: 12,
    name: 'NaturPlus',
    website: 'https://www.naturplus.it',
    logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSKtjAHsreJ2O9Yyv6Aqg3nNk3tLRw-YN5CnQ&s',
    categories: ['Negozio Bio', 'Integratori Naturali', 'Cura Persona'],
    description:
      'Negozio specializzato in prodotti biologici, integratori naturali e prodotti per la cura della persona.',
    productsDescription: 'negozio bio, integratori naturali, cura persona',
    locations: 7,
    activeRewards: 6,
    totalRedemptions: 1420,
    conversionRate: 11.9,
    joinedDate: '2024-04-01',
  },
]

// Extract all unique categories from partners
export const allCategories = Array.from(
  new Set(partners.flatMap((partner) => partner.categories)),
).sort()

// AI Insights for partners (can be hidden/regenerated by admin)
export interface AIInsight {
  id: string
  partnerId: number
  type: 'opportunity' | 'warning' | 'trend' | 'recommendation'
  title: string
  description: string
  visible: boolean
  generatedAt: string
}

export const aiInsights: AIInsight[] = [
  {
    id: 'ai-1',
    partnerId: 1,
    type: 'opportunity',
    title: 'Crescita utenti attivi +23%',
    description:
      'La Saponaria mostra una crescita costante di utenti attivi negli ultimi 3 mesi. Consigliato aumentare la disponibilità di premi.',
    visible: true,
    generatedAt: '2025-01-07T10:30:00',
  },
  {
    id: 'ai-2',
    partnerId: 2,
    type: 'trend',
    title: 'Picco riscatti weekend',
    description:
      'NaturaSì registra il 65% dei riscatti durante il weekend. Ottimizzare le campagne per il fine settimana.',
    visible: true,
    generatedAt: '2025-01-07T09:15:00',
  },
  {
    id: 'ai-3',
    partnerId: 7,
    type: 'recommendation',
    title: 'Espansione categorie suggerita',
    description:
      'Coop Italia potrebbe beneficiare dall\'aggiunta di prodotti nella categoria "Cosmesi Naturale" basandosi sui trend utenti.',
    visible: true,
    generatedAt: '2025-01-07T11:45:00',
  },
]
